"use client";

import { SessionProvider } from "next-auth/react";
import { HeroUIProvider, ToastProvider } from "@heroui/react";
import { AuthWatcher } from "@/components/AuthWatcher";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <HeroUIProvider>
        <ToastProvider />
        <AuthWatcher>{children}</AuthWatcher>
      </HeroUIProvider>
    </SessionProvider>
  );
}
